import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  AnnouncementStatus,
  CreateAnnouncementCardData,
  CreateAnnouncementCardResponse,
  CreateAnnouncementResponse,
  DetailProps,
  GetAnnouncementResponse,
  GetAnnouncementsResponse,
  UpdateAnnouncementCardData,
} from './types';

export const getAnnouncements = (
  status?: AnnouncementStatus,
  page = 1,
  size = 10
): Promise<GetAnnouncementsResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };

  const query = new URLSearchParams();
  query.set('page', String(page));
  query.set('size', String(size));
  if (status) query.set('status', status);

  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/announcements?${query.toString()}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const getAnnouncementById = (
  id: number
): Promise<GetAnnouncementResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcements/${id}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const createAnnouncement = (
  title: string
): Promise<CreateAnnouncementResponse> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify({ title }),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcements`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const updateAnnouncementTitle = (
  id: number,
  title: string
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify({ title }),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcements/${id}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const updateAnnouncementStatus = (
  id: number,
  status: AnnouncementStatus
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify({ status }),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcements/${id}/status`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const deleteAnnouncement = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcements/${id}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const createAnnouncementCard = (
  announcementId: number,
  data: CreateAnnouncementCardData
): Promise<CreateAnnouncementCardResponse> => {
  const formData = new FormData();
  formData.append('rich_title', data.richTitle);
  formData.append('rich_text', data.richText);
  if (data.videoUrl) formData.append('video_url', data.videoUrl);
  if (data.image) formData.append('image', data.image);

  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: formData,
  };

  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/announcements/${announcementId}/cards`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const updateAnnouncementCard = (
  cardId: number,
  data: UpdateAnnouncementCardData
): Promise<DetailProps> => {
  const formData = new FormData();
  if (data.richTitle !== undefined) {
    formData.append('rich_title', data.richTitle);
  }
  if (data.richText !== undefined) {
    formData.append('rich_text', data.richText);
  }
  if (data.videoUrl !== undefined) {
    formData.append('video_url', data.videoUrl);
  }
  if (data.image) {
    formData.append('image', data.image);
  }
  if (data.removeImage !== undefined) {
    formData.append('remove_image', String(data.removeImage));
  }

  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithToken(),
    body: formData,
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcement-cards/${cardId}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const deleteAnnouncementCard = (
  cardId: number
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/announcement-cards/${cardId}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const reorderAnnouncementCards = (
  announcementId: number,
  cardIds: number[]
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify({ card_ids: cardIds }),
  };

  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/announcements/${announcementId}/cards/order`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};
